<template>
    <upload></upload>
</template>

<script>
    import Upload from '../../adv/upload'

    export default {
        components: {Upload},
        data() {
            return {}
        },
        methods: {
        }
    }
</script>

<style type="text/scss" lang="scss" scoped>
    .searchTerms {

    }
</style>
